<div class="legend-item-column col" *ngFor="let legendItemsCol of legendItems">
  <pcs-legend-item
    *ngFor="let legendItem of legendItemsCol"
    [legendItem]="legendItem">
  </pcs-legend-item>
</div>
